import { produce } from "immer";
import { useNavigate } from "react-router-dom";
import { SET_NOTIFICATION_ARRAY, SET_STEPPER_LABEL } from "./crumbs.type";

const INITAL_STATE = {
    sessionData: {
        bellNotification: []
    },
    steppersData: {
        currentStepId: "",
        dataAssetsSteps: [
            { id: "0", value: "dataAssets", label: "Data Assets" },
        ],
        dataAssetSteps: [
            { id: "0", value: "dataAssets", label: "Data Assets" },
            { id: "1", value: "dataAsset", label: "Data Label" },
        ],
        dataDomainSteps: [
            { id: "0", value: "dataDomains", label: "Data Domains" },
        ],
        dataDashboardSteps: [
            { id: "0", value: "Dashboard", label: "Dashboard" },
        ],
        dataSubDomainSteps: [
            { id: "0", value: "dataDomains", label: "Data Domains" },
            { id: "1", value: "dataSubDomains", label: "Sub Domains" },
        ],
        dataAccessManagementSteps: [
            { id: "0", value: "accessManagement", label: "Access Management" },
        ],
         RuleElevation: [
            { id: "0", value: "rule", label: "Rule Elevation" },
        ]
    }

}

const crumbsReducer = (state = INITAL_STATE, { type, payload }) => {
    switch (type) {
        case SET_STEPPER_LABEL: {
            return produce(state, (draft) => {
                draft.steppersData[payload.field][payload.id].label = payload.value
            });
        }
        case SET_NOTIFICATION_ARRAY:{
            return produce(state, (draft) => {
                draft.sessionData.bellNotification = payload.value
            });
        }
        // Return the current state if no action matches
        default:
            return state;
    }
}
export default crumbsReducer;